module.exports = __webpack_public_path__ + "images/63376a2ed4376a9ba7e7bfa57de554d0.svg";